<div class="row justify-content-center">
    <div class="col-lg-8">
        <div class="card">
            <div class="card-header bg-info">
                <h4 class="m-b-0 text-white">Terman - Merril</h4>
            </div>
            <div class="card-body">
                <form [formGroup]="termanForm" (ngSubmit)="register()">
                    <div class="row">
                        <div class="col-md-6">
                            <div  >
                                <label class="control-label">Serie</label>
                                <select formControlName="serie" (change)="setSelectedPart($event)" class="form-control custom-select">
                                    <option *ngFor="let n of numbers" [value]="n">Serie {{n}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="form-body">
                        <div class="row p-t-20">
 
                            <div *ngIf="type=='1'" class="m-t-20">
                                <div class="col-md-12">
                                    <div class="form-group">
                                        <label class="control-label">Título</label>
                                        <input formControlName="title" type="text"  class="form-control" placeholder="Título">
                                    </div>
                                </div>
                                <div class="row col-md-12" formGroupName="opcA">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">Texto opción A</label>
                                            <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción A">
                                        </div>
                                    </div>
                                    <div class="col-md-6">    
                                        <div class="form-group">
                                            <label class="control-label">Valor opción A</label>
                                            <input formControlName="value" type="number"  class="form-control" placeholder="Valor opción A">
                                        </div>
                                    </div>
                                </div>
    
                                <div class="row col-md-12" formGroupName="opcB">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">Texto opción B</label>
                                            <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción B">
                                        </div>
                                    </div>
                                    <div class="col-md-6">    
                                        <div class="form-group">
                                            <label class="control-label">Valor opción B</label>
                                            <input formControlName="value" type="number"  class="form-control" placeholder="Valor opción B">
                                        </div>
                                    </div>
                                </div>
    
                                <div class="row col-md-12" formGroupName="opcC">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">Texto opción C</label>
                                            <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción C">
                                        </div>
                                    </div>
                                    <div class="col-md-6">    
                                        <div class="form-group">
                                            <label class="control-label">Valor opción C</label>
                                            <input formControlName="value" type="number"  class="form-control" placeholder="Valor opción C">
                                        </div>
                                    </div>
                                </div>
                                <div class="row col-md-12" formGroupName="opcD">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">Texto opción D</label>
                                            <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción D">
                                        </div>
                                    </div>
                                    <div class="col-md-6">    
                                        <div class="form-group">
                                            <label class="control-label">Valor opción D</label>
                                            <input formControlName="value" type="number"  class="form-control" placeholder="Valor opción D">
                                        </div>
                                    </div>
                                    
                                </div>

                            </div>
                            <div *ngIf="type=='2'" class="col-12 m-t-20">

                                <div class="form-group">
                                    <label class="control-label">Título</label>
                                    <input formControlName="title" type="text"  class="form-control" placeholder="Título">
                                </div>
 
                                <div class="row col-md-12" formGroupName="opcA">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">Texto opción A</label>
                                            <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción A">
                                        </div>
                                    </div>
                                    <div class="col-md-6">    
                                        <div class="form-group">
                                            <label class="control-label">Valor opción A</label>
                                            <input formControlName="value" type="number"  class="form-control" placeholder="Valor opción A">
                                        </div>
                                    </div>
                                </div>
    
                                <div class="row col-md-12" formGroupName="opcB">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">Texto opción B</label>
                                            <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción B">
                                        </div>
                                    </div>
                                    <div class="col-md-6">    
                                        <div class="form-group">
                                            <label class="control-label">Valor opción B</label>
                                            <input formControlName="value" type="number"  class="form-control" placeholder="Valor opción B">
                                        </div>
                                    </div>
                                </div>
    
                                <div class="row col-md-12" formGroupName="opcC">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">Texto opción C</label>
                                            <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción C">
                                        </div>
                                    </div>
                                    <div class="col-md-6">    
                                        <div class="form-group">
                                            <label class="control-label">Valor opción C</label>
                                            <input formControlName="value" type="number"  class="form-control" placeholder="Valor opción C">
                                        </div>
                                    </div>
                                </div>
                                

                            </div>
                            <div *ngIf="type=='3'" class="col-12 m-t-20">
                                <div class="row col-md-12" formGroupName="pair">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">Texto</label>
                                            <input formControlName="text" type="text"  class="form-control" placeholder="Texto">
                                        </div>
                                    </div>
                                    <div class="col-md-6">    
                                        <div class="form-group">
                                            <label class="control-label">Valor</label>
                                            <input formControlName="value" type="text"  class="form-control" placeholder="(i)/gual - (o)puesto">
                                        </div>
                                    </div>
                                </div>
                                

                            </div>

                            <div *ngIf="type=='4'" class="m-t-20">
                                <div class="form-group">
                                    <label class="control-label">Título</label>
                                    <input formControlName="title" type="text"  class="form-control" placeholder="Título">
                                </div>
                                <div class="row col-md-12" formGroupName="doubleSelection">
                                    <div class="row col-md-12" formGroupName="opcA">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="control-label">Texto opción A</label>
                                                <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción A">
                                            </div>
                                        </div>
                                        <div class="col-md-6">    
                                            <div class="form-group">
                                                <label class="control-label">Valor opción A</label>
                                                <div class="col-md-12">
                                                    <div class="switch">
                                                        <label><input formControlName="value" type="checkbox" checked=""><span class="lever"></span>Selección</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
        
                                    <div class="row col-md-12" formGroupName="opcB">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="control-label">Texto opción B</label>
                                                <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción B">
                                            </div>
                                        </div>
                                        <div class="col-md-6">    
                                            <div class="form-group">
                                                <label class="control-label">Valor opción B</label>
                                                <div class="col-md-12">
                                                    <div class="switch">
                                                        <label><input formControlName="value" type="checkbox" checked=""><span class="lever"></span>Selección</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
        
                                    <div class="row col-md-12" formGroupName="opcC">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="control-label">Texto opción C</label>
                                                <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción C">
                                            </div>
                                        </div>
                                        <div class="col-md-6">    
                                            <div class="form-group">
                                                <label class="control-label">Valor opción C</label>
                                                <div class="col-md-12">
                                                    <div class="switch">
                                                        <label><input formControlName="value" type="checkbox" checked=""><span class="lever"></span>Selección</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row col-md-12" formGroupName="opcD">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="control-label">Texto opción D</label>
                                                <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción D">
                                            </div>
                                        </div>
                                        <div class="col-md-6">    
                                            <div class="form-group">
                                                <label class="control-label">Valor opción D</label>
                                                <div class="col-md-12">
                                                    <div class="switch">
                                                        <label><input formControlName="value" type="checkbox" checked=""><span class="lever"></span>Selección</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div>
                                    <div class="row col-md-12" formGroupName="opcE">
                                        <div class="col-md-6">
                                            <div class="form-group">
                                                <label class="control-label">Texto opción E</label>
                                                <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción E">
                                            </div>
                                        </div>
                                        <div class="col-md-6">    
                                            <div class="form-group">
                                                <label class="control-label">Valor opción E</label>
                                                <div class="col-md-12">
                                                    <div class="switch">
                                                        <label><input formControlName="value" type="checkbox" checked=""><span class="lever"></span>Selección</label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="type=='5'" class="col-12 m-t-20">
                                <div class="form-group">
                                    <label class="control-label">Título</label>
                                    <input formControlName="title" type="text"  class="form-control" placeholder="Título">
                                </div>
                                <div class="row col-md-12" formGroupName="numbers">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">Valor</label>
                                            <input formControlName="value" type="number"  class="form-control" placeholder="Valor">
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="type=='6'" class="col-12 m-t-20">
                                <div class="form-group">
                                    <label class="control-label">Título</label>
                                    <input formControlName="title" type="text"  class="form-control" placeholder="Título">
                                </div>
                                <div class="row col-md-12" formGroupName="boolean">

                                    <div class="col-md-6">    
                                        <div class="form-group">
                                            <label class="control-label">Valor</label>
                                            <input formControlName="value" type="text"  class="form-control" placeholder="(s)i - (n)o">
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="type=='7'" class="m-t-20">

                                <div class="form-group">
                                    <label class="control-label">Título</label>
                                    <input formControlName="title" type="text"  class="form-control" placeholder="Título">
                                </div>

                                <div class="row col-md-12" formGroupName="opcA">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">Texto opción A</label>
                                            <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción A">
                                        </div>
                                    </div>
                                    <div class="col-md-6">    
                                        <div class="form-group">
                                            <label class="control-label">Valor opción A</label>
                                            <input formControlName="value" type="number"  class="form-control" placeholder="Valor opción A">
                                        </div>
                                    </div>
                                </div>
    
                                <div class="row col-md-12" formGroupName="opcB">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">Texto opción B</label>
                                            <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción B">
                                        </div>
                                    </div>
                                    <div class="col-md-6">    
                                        <div class="form-group">
                                            <label class="control-label">Valor opción B</label>
                                            <input formControlName="value" type="number"  class="form-control" placeholder="Valor opción B">
                                        </div>
                                    </div>
                                </div>
    
                                <div class="row col-md-12" formGroupName="opcC">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">Texto opción C</label>
                                            <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción C">
                                        </div>
                                    </div>
                                    <div class="col-md-6">    
                                        <div class="form-group">
                                            <label class="control-label">Valor opción C</label>
                                            <input formControlName="value" type="number"  class="form-control" placeholder="Valor opción C">
                                        </div>
                                    </div>
                                </div>
                                <div class="row col-md-12" formGroupName="opcD">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">Texto opción D</label>
                                            <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción D">
                                        </div>
                                    </div>
                                    <div class="col-md-6">    
                                        <div class="form-group">
                                            <label class="control-label">Valor opción D</label>
                                            <input formControlName="value" type="number"  class="form-control" placeholder="Valor opción D">
                                        </div>
                                    </div>
                                    
                                </div>

                            </div>

                            <div *ngIf="type=='8'" class="col-12 m-t-20">
                                <div class="form-group">
                                    <label class="control-label">Título</label>
                                    <input formControlName="title" type="text"  class="form-control" placeholder="Título">
                                </div>
                                <div class="row col-md-12" formGroupName="boolean">
           
                                    <div class="col-md-6">    
                                        <div class="form-group">
                                            <label class="control-label">Valor</label>
                                            <input formControlName="value" type="text"  class="form-control" placeholder="(v)erdader - (f)also">
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div *ngIf="type=='9'" class="m-t-20">

                                <div class="row col-md-12" formGroupName="opcA">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">Texto opción A</label>
                                            <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción A">
                                        </div>
                                    </div>
                                    <div class="col-md-6">    
                                        <div class="form-group">
                                            <label class="control-label">Valor opción A</label>
                                            <input formControlName="value" type="number"  class="form-control" placeholder="Valor opción A">
                                        </div>
                                    </div>
                                </div>
    
                                <div class="row col-md-12" formGroupName="opcB">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">Texto opción B</label>
                                            <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción B">
                                        </div>
                                    </div>
                                    <div class="col-md-6">    
                                        <div class="form-group">
                                            <label class="control-label">Valor opción B</label>
                                            <input formControlName="value" type="number"  class="form-control" placeholder="Valor opción B">
                                        </div>
                                    </div>
                                </div>
    
                                <div class="row col-md-12" formGroupName="opcC">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">Texto opción C</label>
                                            <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción C">
                                        </div>
                                    </div>
                                    <div class="col-md-6">    
                                        <div class="form-group">
                                            <label class="control-label">Valor opción C</label>
                                            <input formControlName="value" type="number"  class="form-control" placeholder="Valor opción C">
                                        </div>
                                    </div>
                                </div>
                                <div class="row col-md-12" formGroupName="opcD">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">Texto opción D</label>
                                            <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción D">
                                        </div>
                                    </div>
                                    <div class="col-md-6">    
                                        <div class="form-group">
                                            <label class="control-label">Valor opción D</label>
                                            <input formControlName="value" type="number"  class="form-control" placeholder="Valor opción D">
                                        </div>
                                    </div>
                                    
                                </div>
                                <div class="row col-md-12" formGroupName="opcE">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">Texto opción E</label>
                                            <input formControlName="text" type="text"  class="form-control" placeholder="Texto opción E">
                                        </div>
                                    </div>
                                    <div class="col-md-6">    
                                        <div class="form-group">
                                            <label class="control-label">Valor opción E</label>
                                            <input formControlName="value" type="number"  class="form-control" placeholder="Valor opción E">
                                        </div>
                                    </div>
                                    
                                </div>

                            </div>

                            <div *ngIf="type=='10'" class="col-12 m-t-20">
                                <div class="form-group">
                                    <label class="control-label">Secuencia</label>
                                    <input formControlName="title" type="text"  class="form-control" placeholder="Secuencia">
                                </div>
                                <div class="row col-md-12" formGroupName="textNumbers">
                                    <div class="col-md-6">
                                        <div class="form-group">
                                            <label class="control-label">Primer valor</label>
                                            <input formControlName="firstValue" type="text"  class="form-control" placeholder="Texto">
                                          
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group">

                                            <label class="control-label">Segundo valor</label>
                                            <input formControlName="secondValue" type="text"  class="form-control" placeholder="Texto">
                                        </div>
                                    </div>
                                </div>
                            </div>




                        </div>
                      
                    </div>
                    <div class="form-actions m-t-20">
                        <button type="submit" class="btn btn-success m-r-20"> <i class="fa fa-check"></i> Guardar</button>
                        <button type="button" class="btn btn-inverse" (click)="reset()">Reiniciar</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
